module.exports = __webpack_public_path__ + "static/media/mainicon.6d4df390.png";